import React from 'react'

const Manual_orden_categorias = () => {
  return (
    <>
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
        <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
        Orden de Categorías
        </h2>
        <p className="text-lg text-gray-700 mb-6">
        Esta guía ayuda a organizar y personalizar el orden de las categorías en el menú, optimizando su
        organización tanto para la app de InvuPOS como en cualquier integración de e-Commerce.
        </p>
        <iframe
        src="https://scribehow.com/embed/Orden_de_Categorias__dQV2MSBHRPaqQ9q5OxLdFQ?as=scrollable"
        className="scribe-iframe-general-28"
        width="100%"
        height="3300"
        allowFullScreen
        style={{ border: 0, minHeight: '640px' }}
        ></iframe>
        </div>
    </div>
    </>
  )
}

export default Manual_orden_categorias